module.exports = __webpack_public_path__ + "static/media/alogent-logo-inverse.92a8cda5.png";